// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-viewer {
    background-color: #404346;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: stretch;
    max-height: 100vh;
}

.aiiif-plain-text {
    background-color: #ffffff;
    padding: 30px;
    width: 540px;
    margin: 0 auto;
    overflow-y: auto;
    align-self: center;
    max-height: 90%;
}

.aiiif-viewer-html {
    background-color: #ffffff;
    margin: 0 auto;
    overflow-y: auto;
    align-self: center;
    max-height: 90%;
    padding: 18px;
    margin: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/viewer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,YAAY;AAChB","sourcesContent":[".aiiif-viewer {\n    background-color: #404346;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    align-items: stretch;\n    max-height: 100vh;\n}\n\n.aiiif-plain-text {\n    background-color: #ffffff;\n    padding: 30px;\n    width: 540px;\n    margin: 0 auto;\n    overflow-y: auto;\n    align-self: center;\n    max-height: 90%;\n}\n\n.aiiif-viewer-html {\n    background-color: #ffffff;\n    margin: 0 auto;\n    overflow-y: auto;\n    align-self: center;\n    max-height: 90%;\n    padding: 18px;\n    margin: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
